// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"cc652de0","543":"46ee393b","583":"867a661e","844":"8ec75d89","845":"8ea892ac","983":"1b926913"}[chunkId] + ".chunk.js";
};